import { Configuration, LogLevel } from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID}`,
    redirectUri: import.meta.env.VITE_AZURE_REDIRECT_URI || window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
        }
      },
      logLevel: LogLevel.Warning,
    },
  },
};

// Conversions doesn't talk to Dataverse directly — the loginRequest scope is the
// API itself. (ptc-statetax includes Dataverse scopes because it reads client
// metadata; we read from ptc-statetax's bridge endpoint instead.)
export const loginRequest = {
  scopes: [`api://${import.meta.env.VITE_AZURE_API_CLIENT_ID}/access_as_user`],
};

export const apiScopes = [
  `api://${import.meta.env.VITE_AZURE_API_CLIENT_ID}/access_as_user`,
];
